var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6465 0.332766C11.8295 0.515792 11.8295 0.815272 11.6465 0.998298L1.80022 10.8446L21.9619 10.8412C22.2215 10.8479 22.4278 11.0608 22.4244 11.317C22.4178 11.57 22.2148 11.7729 21.9619 11.7796L1.80022 11.7829L11.6464 21.6291C11.8295 21.8121 11.8295 22.1116 11.6465 22.2947C11.4634 22.4777 11.164 22.4777 10.9809 22.2947L0.332766 11.6465C0.14974 11.4634 0.14974 11.164 0.332766 10.9809L10.9809 0.332766C11.164 0.14974 11.4634 0.14974 11.6465 0.332766Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.ca1b793bf3ed7bae675ef6b469ff7520.svg";
export { ForwardRef as ReactComponent };